import React from "react";

interface CourseActionCardProps {
  title: string;
  cardText: string;
  buttonText: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const CourseActionCard = ({
  title,
  cardText,
  buttonText,
  icon,
  onClick,
}: CourseActionCardProps) => {
  return (
    <div className="card flex max-h-48 w-full flex-wrap gap-x-8 gap-y-4 bg-neutral shadow-xl md:w-96">
      <div className="card-body p-4">
        <h2 className="card-title">{title}</h2>
        <p>{cardText}</p>
        <div className="card-actions justify-end">
          <button
            type="button"
            className="btn btn-primary flex w-full justify-between border-b-2 shadow-sm hover:shadow-lg sm:w-60"
            onClick={onClick}
          >
            <span className="font-semibold text-md sm:text-lg">
              {buttonText}
            </span>
            {icon}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseActionCard;
